import React, { useState, useEffect } from 'react';
import { Shield } from 'lucide-react';

const ConsentPopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('akyLegalConsent');
    if (!consent) {
      setShowPopup(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('akyLegalConsent', 'true');
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-8 transform transition-all duration-300 scale-100">
        {/* Icon */}
        <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-gold bg-opacity-10 mb-6">
          <Shield className="h-10 w-10 text-gold" />
        </div>
        
        <h3 className="text-2xl font-bold text-primary-blue mb-3 text-center">
          Privacy Consent
        </h3>
        
        <p className="text-dark-gray mb-8 text-center leading-relaxed">
          We use cookies and similar technologies to enhance your experience. 
          By clicking "I Agree", you consent to our use of cookies in accordance 
          with our Privacy Policy.
        </p>
        
        <div className="space-y-3">
          <button
            onClick={handleAccept}
            className="w-full bg-gold hover:bg-dark-gold text-primary-blue font-semibold py-4 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2"
          >
            I Agree
          </button>
          
          <p className="text-xs text-gray-500 text-center">
            By continuing, you acknowledge that you have read and understood our 
            <a href="/privacy-policy" className="text-gold hover:underline ml-1">Privacy Policy</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConsentPopup;